const DOMAIN = 'api.calenso.io';
const BASE_URL = 'https://' + DOMAIN;

export const environment = {
  apiUrl: BASE_URL + '/api/v1/',
  baseUrl: BASE_URL,
  calioDashboardBaseUrl: 'https://dashboard.calenso.io',
  deployUrl: 'https://widget.calenso.io',
  encryptedKey: 'FtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ',
  eventImgBaseUrl: BASE_URL + '/webroot/files/events/image/',
  eventImgFallback: 'brand/default-logo.png',
  footerLogoUrl: 'brand/footer-logo.svg',
  logoBaseUrl: BASE_URL + '/webroot/files/partners/logo/',
  production: false,
  sentryDsn: 'https://4a3a465a05d39ec80baf0f227dce9786@o4506308503273472.ingest.sentry.io/4506339323609088',
  stripe: {
    publishableKey: 'pk_test_qC6Q2zbwLgHgHEzXkHdKATbR',
  },
  version: '9.4.1',
  brandName: 'Calenso',
  brandUrls: {
    BRAND_WEBSITE: 'https://www.calenso.com',
    BRAND_TERMS_URL: 'https://www.calenso.com/agb/',
    BRAND_PRIVACY_URL: 'https://www.calenso.com/datenschutz/',
    BRAND_SUPPORT_EMAIL: 'support@calenso.com',
  },
  statusUrl: 'https://status.calenso.com',
  maintenanceImagePath: '/img/calenso_maintenance.svg',
  workerAvatarUrl: BASE_URL + '/webroot/files/workers/avatar/',
  bookingElementName: 'calenso-booking',
  defaultLocale: 'de_CH',
};
